import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function TemplateEngine() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Template Engine</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Attraverso i Template Engine possono andare a creare dei layout predefiniti (template) che verrano utilizzati come scheletri per costruire il sito.
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>


            {/* INIZIO CODICE HTML - index.html */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="html"
                description="Come prima cosa creo una semplice pagina HTML (index.html)"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco Template Engine</title>
</head>
<body>
    
    <h1>Template Engine</h1>

</body>
</html>`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE HTML - index.html */}


            {/* INIZIO CODICE JAVASCRIPT - server.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Funzionamento dei template (file 'server.js')"
                code={`const express = require("express");
const app = express();
const port = 3000;

app.set("views", "./views");
app.set("view engine", "ejs");

//Implemento la funzione
app.get("/", (req, res) => {
    const dati = "Mattia Bracco"
    
    /*
    Il 1° parametro è il file del mio template (index.ejs) scritto senza esetnzione (senza .ejs)
    Il 2° parametro è un object literal con i dati da passare ( {variabile : valore} ) 
    */
    res.render("index", {variabile : dati})
});

//Avvio il server
app.listen(port, () => {
    console.log("Servizio in esecuzione sulla porta 3000")
})`}
            />
            {/* Fine snippet del codice */}

            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Posso anche utilizzare un object literal per il passaggio dei parametri come in questo caso (file 'server.ejs')"
                code={`app.get("/", (req, res) => {
    let persona = {
        nome: "Mario",
        cognome: "Rossi",
        eta: 40,
        targa: "AA001AA",
        CF: "ABCDEF11"
    }
    /*
    Il 1° parametro è il file del mio template (index.ejs) scritto senza esetnzione (senza .ejs)
    Il 2° parametro è un object literal con i dati da passare ( {variabile : valore} ) 
    */
    res.render("index", {variabile : persona})
});`}
            />
            {/* Fine snippet del codice */}        
            {/* FINE CODICE JAVASCRIPT - server.js */}

            {/* INIZIO CODICE EJS - index.ejs */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="ejs"
                description="Template creato in 'views/index.ejs' (i parametri ricevuti sono dell'esempio con l'object literal)"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco EJS</title>
</head>
<body>
    <!-- Questo codice si chiama EJS, viene interpretato dal server -->
    <!-- Il client interpreta solo HTML, CSS e JavaScript ! -->
    BENVENUTO <%= variabile.nome + " " + variabile.cognome + " (" + variabile.CF + ")"%>
</body>
</html>`}
            />
            {/* Fine snippet del codice */}        
            {/* FINE CODICE EJS - index.ejs */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/template_engine_object_literal" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}

            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Template Engine con invio parametri</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Esempio con l'invio dei parametri da parte di una Web App
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
            </div>


            {/* INIZIO CODICE HTML - index.html */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="html"
                description="Come prima cosa creo una semplice pagina HTML (index.html) (invariata da quella dell'esempio precedente)"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco Template Engine</title>
</head>
<body>
    
    <h1>Template Engine</h1>

</body>
</html>`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE HTML - index.html */}


            {/* INIZIO CODICE JAVASCRIPT - server.js */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="javascript"
                description="Funzionamento dei template (file 'server.js')"
                code={`const express = require("express");
const app = express();
const port = 3000;

app.set("views", "./views");
app.set("view engine", "ejs");

//PER UTILIZZARE I PARAMETRI IN POST
/*
Per parsare il JSON
Io ho una stringa --> la trasformo in JSON
Così posso scrivere ".nome", ".cognome", ecc. altrimenti dovrei fare la split
*/
app.use(express.json());
app.use(express.urlencoded({
    extended: true
}))


//Implemento la funzione (sta volta è APP.POST))
app.post("/recupera", (req, res) => {
    let persona = {
        nome: req.body.nome,
        cognome: req.body.cognome,
        CF: req.body.CF
    }
    /*
    Il 1° parametro è il file del mio template (index.ejs) scritto senza esetnzione (senza .ejs)
    Il 2° parametro è un object literal con i dati da passare ( {variabile : valore} ) 
    */
    res.render("index", {variabile : persona})
});

//Avvio il server
app.listen(port, () => {
    console.log("Servizio in esecuzione sulla porta 3000")
})`}
            />
            {/* Fine snippet del codice */}
            {/* FINE CODICE JAVASCRIPT - server.js */}

            {/* INIZIO CODICE EJS - index.ejs */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="ejs"
                description="Template creato in 'views/index.ejs' (i parametri ricevuti sono dell'esempio con l'object literal) (invariato da quello dell'esempio precedente)"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco EJS</title>
</head>
<body>
    <!-- Questo codice si chiama EJS, viene interpretato dal server -->
    <!-- Il client interpreta solo HTML, CSS e JavaScript ! -->
    BENVENUTO <%= variabile.nome + " " + variabile.cognome + " (" + variabile.CF + ")"%>
</body>
</html>`}
            />
            {/* Fine snippet del codice */}        
            {/* FINE CODICE EJS - index.ejs */}

            {/* INIZIO CODICE HTML - Web App */}
            {/* Inizio snippet del codice */}
            <CodeSnippet
                language="html"
                description="Pagina 'index.html' che rappresenta la mia Web App, posso salvarla in un percorso diverso come sul Desktop dato che tanto è collegata al servizio (server.js) tramite l'action presente nel form"
                code={`<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>5L Bracco Web App EJS</title>
</head>
<body>
    
    <h1>Template Engine</h1>

    <!-- Inizio del form -->
    <form action="http://127.0.0.1:3000/recupera" method="POST">
        <!-- Input del nome -->
        <input type="text" name="nome" placeholder="Inserisci il nome">

        <!-- Input del cognome -->
        <input type="text" name="cognome" placeholder="Inserisci il cognome">

        <!-- Input del CF -->
        <input type="text" name="CF" placeholder="Inserisci il CF">

        <!-- Button submit per l'invio dei parametri -->
        <input type="submit" value="INVIA DATI">
    </form>
    <!-- Fine del form -->

</body>
</html>`}
            />
            {/* Fine snippet del codice */}        
            {/* FINE CODICE HTML - Web App */}

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/template_engine_invio_parametri" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}

        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default TemplateEngine;
